export enum ConferirNucleoOptions {
  NucleosPresentes = 'nucleosPresentes',
  NucleosAusentes = 'nucleosAusentes',
}
